import './zod-init.ts';
import { StrictMode, startTransition } from 'react';
import { initialize } from '@dinewise/instrumentation/remix/client';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

initialize('payments');

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
